import { UploadCloud } from "lucide-react";

import { ANALYTICS_EVENTS } from "analytics";
import { Button } from "components/common/buttons/Button";
import { useCreateProjectLauncher } from "hooks/project";
import { useAnalytics } from "hooks/useAnalytics";
import { useProjectIdentifiers } from "store/hooks/useProjectIdentifiers";

/**
 * Shown on every page of the seeded demo production. The demo proves what
 * RivetAI does; this turns that into the next step: the user's own script.
 */
export const DemoProjectBanner = () => {
  const { project, projectId } = useProjectIdentifiers(false);
  const { trackEvent } = useAnalytics();
  const { launchCreateProject, createProjectFlowElement, canCreateWorkspaceProject } =
    useCreateProjectLauncher();

  if (!project?.isDemo || !canCreateWorkspaceProject) {
    return null;
  }

  const handleImport = () => {
    trackEvent(ANALYTICS_EVENTS.DEMO_BANNER_IMPORT_CLICKED, { project_id: projectId });
    launchCreateProject({ initialSource: "import", entrySource: "onboarding" });
  };

  return (
    <>
      <aside
        aria-label="Sample production"
        className="mx-4 mt-4 flex flex-wrap items-center justify-between gap-4 rounded-xl border border-primary/20 bg-primary/[0.04] px-4 py-3 lg:mx-6"
      >
        <div className="flex min-w-0 items-start gap-3">
          <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-primary/10 text-primary">
            <UploadCloud className="h-4 w-4" aria-hidden />
          </span>
          <div className="min-w-0">
            <p className="text-sm font-semibold text-foreground">
              You&apos;re exploring a sample production.
            </p>
            <p className="mt-0.5 text-xs text-muted-foreground">
              Import your screenplay to get the same breakdown, schedule, and budget for yours.
            </p>
          </div>
        </div>
        <Button type="button" color="brand" size="sm" onClick={handleImport} className="shrink-0">
          Import your screenplay
        </Button>
      </aside>
      {createProjectFlowElement}
    </>
  );
};
